import React from "react";
import { TouchableOpacity } from "react-native";
import { AHTag } from "./AHTag";
import { Inline } from "./Inline";

type AHTagSelectProps = {
  selected: string[];
  setSelected: (selected: string[]) => void;
  tags: Readonly<
    {
      id: string;
      title: string;
      color: string;
    }[]
  >;
};

export function AHTagSelect({ selected, setSelected, tags }: AHTagSelectProps) {
  return (
    <Inline space="small">
      {tags.map((tag) => (
        <TouchableOpacity
          key={tag.id}
          onPress={() => {
            if (selected.includes(tag.id)) {
              setSelected([...selected.filter((id) => id !== tag.id)]);
            } else {
              setSelected([...selected.filter((id) => id !== tag.id), tag.id]);
            }
          }}
        >
          <AHTag
            color={tag.color}
            title={tag.title}
            selected={selected.includes(tag.id)}
          />
        </TouchableOpacity>
      ))}
    </Inline>
  );
}
